export const MUTATIONS_RELEASES = {
  UPDATE_RELEASES_STATE: 'updateReleasesState'
};

export default {
  updateReleasesState(state, { showReleasesIcon, hasRecentRelease }) {
    if (showReleasesIcon !== undefined) {
      state.showReleasesIcon = showReleasesIcon;
    }
    
    if (hasRecentRelease !== undefined) {
      state.hasRecentRelease = hasRecentRelease;
    }
  }
};
